import { defineMessages, useIntl } from 'react-intl';

const m = defineMessages({
  currentMonth: {
    id: 'Period.CurrentMonth',
    defaultMessage: 'du mois courant',
  },
  previousMonth: {
    id: 'Period.PreviousMonth',
    defaultMessage: 'du mois précédent',
  },
  currentYear: {
    id: 'Period.CurrentYear',
    defaultMessage: "de l'année en cours",
  },
  previousYear: {
    id: 'Period.PreviousYear',
    defaultMessage: "de l'année précédente",
  },
  custom: {
    id: 'Period.Custom',
    defaultMessage: 'de dates personnalisées',
  },
});

export const usePeriodOptions = () => {
  const { formatMessage } = useIntl();

  const periodOptions = [
    {
      key: 'current month',
      text: formatMessage(m.currentMonth),
      value: 'current month',
    },
    {
      key: 'previous month',
      text: formatMessage(m.previousMonth),
      value: 'previous month',
    },
    {
      key: 'current year',
      text: formatMessage(m.currentYear),
      value: 'current year',
    },
    {
      key: 'previous year',
      text: formatMessage(m.previousYear),
      value: 'previous year',
    },
    {
      key: 'custom',
      text: formatMessage(m.custom),
      value: 'custom',
    },
  ];

  return { periodOptions };
};
